import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';
import { formatDate } from '@angular/common';

@Injectable()
export class NotificationService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    getAllMessages() : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/notification/';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    updateMessage(message) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/notification/update/';
        message.messageEndDate = formatDate(message.messageEndDate, 'yyyy-MM-dd', 'en');

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('messageBody', JSON.stringify(message));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }
}
